export default __webpack_public_path__ + "static/media/webmail.6d4f6dc8.png";